import { EnumOption } from "@phrmpc/shared";

export const toEnumOptions = (
  items: { id?: number; code?: string; name?: string }[],
): EnumOption[] =>
  items
    .filter((i) => i.id != null && i.code != null && i.name != null)
    .map((i) => ({ id: i.id!, code: i.code!, name: i.name! }));
